export class UserModel {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
  groups: Array<GroupModel>;
  groupsAsHtml: any;
  personaAsHtml: any;
  customerNumbersAsHtml: any;
  serviceProviderNumbersAsHtml: any;
  serviceProviderNamesAsHtml: any;
  metadataId: string;
  metadata: MetadataModel;
  isEdit: boolean = false;

  constructor() {
    this.metadata = new MetadataModel();
  }
}

/**
 * Converts the User Groups to HTML content for the Vixxo UI Grid.
 * A
 * @param groups: string result.
 */
export function convertToHtmlContent(
  labels: Array<string>,
  isCustomer: boolean
): string {
  let contentAsHtml = '<div class="pull-left">';
  if (labels) {
    labels.sort();
    labels.forEach(label => {
      if (label !== undefined) {
        contentAsHtml = contentAsHtml.concat(
          `<div class="badge group">${label}</div>`
        );
      }
    });
  }
  contentAsHtml = contentAsHtml.concat('</div>');
  if (isCustomer) {
    contentAsHtml = contentAsHtml.concat(`<div class="pull-right group-edit-p"><a class="btn group-edit-c">
    <span class="group-edit glyphicon glyphicon-pencil"></span></a></div>`);
  }
  return contentAsHtml;
}

export class GroupModel {
  id: string;
  name: string;
  description: string;
  type: string;
  persona: string;
}

export class SiteTierArray {
  text: string;
  items: Array<any>;
}

export class SearchSiteTier {
  siteName: string;
  level1Name: string;
  level2Name: string;
  level3Name: string;
  level4Name: string;
  level5Name: string;
  levelId1: string;
  levelId2: string;
  levelId3: string;
  levelId4: string;
  levelId5: string;
  siebelSiteId: string;
}

export class ClaimModel {
  claimType: string;
  claimValue: string;
}

export class MetadataModel {
  constructor() {
    this.customer = new CustomerModel();
    this.serviceProvider = new ServiceProviderModel();
  }
  customer: CustomerModel;
  licenseAcceptance: LicenseAcceptanceModel;
  serviceProvider: ServiceProviderModel;
  serviceCenter: ServiceCenterModel;
  claims: Array<ClaimModel>;
}

export class CustomerModel {
  siteIds: any;
  customerNumbers: any;
}

export class ServiceCenterModel {
  siteIds: any;
  customerNumbers: any;
}

export class ServiceProviderModel {
  serviceProviderNumbers: any;
  serviceProviders: Array<ServiceProvidersModel>;
}

export class LicenseAcceptanceModel {
  version: string;
  date: Date;
}

export class PersonaModel {
  description: string;
  id: string;
  name: string;
  type: string;
  persona: string;
}

export class ServiceProvidersModel {
  id: string;
  name: string;
  number: string;
  phoneNumber: string;
}

export class ServiceProviderUserModel {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  metadata: ServiceProviderMetadataModel;
  isEdit: boolean = false;

  constructor() {
    this.metadata = new ServiceProviderMetadataModel();
  }
}

export class ServiceProviderMetadataModel {
  constructor() {
    this.serviceProvider = new ServiceProviderModel();
  }
  serviceProvider: ServiceProviderModel;
}

export class Sites {
  country: string;
  address: string;
  city: string;
  timezone: string;
  latitude: string;
  isActive: string;
  zipcode: string;
  number: string;
  phoneNumber: string;
  name: string;
  id: string;
  state: string;
  longitude: string;
  siteName: string;
}
